module.exports = __webpack_public_path__ + "static/media/history_20.6b015977.jpg";